import { createContext, useContext, type ReactNode } from "react";

interface ChatLayoutContextValue {
    heroMedia: boolean;
    mobileQuickActions: boolean;
}

const ChatLayoutContext = createContext<ChatLayoutContextValue>({
    heroMedia: false,
    mobileQuickActions: false,
});

interface ChatLayoutProviderProps {
    heroMedia?: boolean;
    mobileQuickActions?: boolean;
    children: ReactNode;
}

export function ChatLayoutProvider({
    heroMedia = false,
    mobileQuickActions = false,
    children,
}: ChatLayoutProviderProps) {
    return (
        <ChatLayoutContext.Provider value={{ heroMedia, mobileQuickActions }}>
            {children}
        </ChatLayoutContext.Provider>
    );
}

export function useChatLayout(): ChatLayoutContextValue {
    return useContext(ChatLayoutContext);
}
